import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { guid } from '@/mixins/guid';

export default Vue.component('confirm-restore-modal', {
  template: require('./template.html'),
  name: 'confirm-restore-modal',
  mixins: [guid],
  computed: {
    ...mapGetters([
      'currentUser',
      'priceSource',
      'websites',
      'account',
    ]),
    backupSiteExists() {
      return this.currentUser.websites.includes(this.activeBackup._id);
    },
    tiers() {
      return this.priceSource.tiers;
    },
    activeSite() {
      // this would be the site in it's current state if there
      return this.websites.find(site => this.activeBackup._id === site._id);
    },
    samePlan() {
      const activeSite = this.activeSite || {};
      const backupSite = this.activeBackup || {};
      // we don't want to allow restores if plans have been changed,
      // users will need to downgrade / upgrade manually first
      return activeSite.tier === backupSite.tier;
    },
  },
  data() {
    return {
      loading: false,
      sendErrors: false,
      chosenDateFormat: null,
      agreedCharge: true,
    };
  },
  props: [
    'toggle-modal',
    'modal',
    'active-backup',
    'chosen-date',
    'checks',
  ],
  watch: {
    modal(open) {
      if (open) {
        this.chosenDateFormat = moment(this.chosenDate).format('MMM DD, YYYY');
      }
    },
  },
  methods: {
    async restoreWebsite() {
      const plan = this.activeBackup.tier;
      if (plan === 'Free' || (plan === 'Starter' && this.checks.passedStarter)) {
        return;
      }
      if (!this.currentUser.paymentMethod && !this._isExempt) {
        this.sendErrors = 'It looks like you do not have a payment method on file. You will need to set one up in order to proceed.';
        return;
      }
      this.loading = true;
      this.sendErrors = false;
      try {
        const { restoredSite } = await this.$lightning([{
          name: 'restoreWebsite',
          payload: {
            _id: this.activeBackup._id,
            date: moment(this.chosenDate).format('YYYY-MM-DD'),
          },
        }]);
        this.$store.dispatch('readdGlobalArray', {
          list: this.currentUser.websites,
          value: restoredSite._id,
          payload: restoredSite._id,
        });
        this.$store.dispatch('readdGlobalArray', {
          list: this.account.websites,
          key: '_id',
          value: restoredSite._id,
          payload: restoredSite,
        });
        this.$store.dispatch('readdGlobalArray', {
          list: this.websites,
          key: '_id',
          value: restoredSite._id,
          payload: restoredSite,
        });
        this.closeModal('confirmRestore');
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: `Successfully restored ${this.activeBackup.alias} to ${this.chosenDateFormat}!`,
          time: 5000,
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.sendErrors = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'restoreWebsite',
        });
      } finally {
        this.loading = false;
      }
    },
    getPrice() {
      let price = 0;
      const plan = this.activeBackup && this.activeBackup.tier;
      if (!this._isBundle && !this._isExempt) {
        price = this.tiers[plan] && this.tiers[plan].price;
      }
      return price;
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(arr) {
      return arr.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/support/backups/confirm-restore/index.js